<template>
<h3> Prepare Status</h3>
</template>
<script>
export default {
    components:{

    },
    provide() {
        return {
            parentValidator: this.$validator,
        };
    },
    data: () => ({

    }),
    props:{

    },
    methods:{

    },
    mounted(){
        this.showToster({ message: 'Sign Document Template is Updated Successfully', isError: false });
        setTimeout(()=>{
            const dataToSend = { message: 'Hello from the child window!',
                closePopup:true};
            console.log(" datatosend ", dataToSend);
            console.log("target window origin ", window.location.origin);
            window.parent.postMessage(dataToSend, '*');
        },1000)
    }
}

</script>